module.exports = __webpack_public_path__ + "media/unipod/multi-use-pod-card-picture-5f743939.jpg";